import script from "./ConsoleOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsoleOverview.vue?vue&type=script&setup=true&lang=js"

import "./ConsoleOverview.vue?vue&type=style&index=0&id=1bd1eeb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bd1eeb4"]])

export default __exports__